var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import trackers from "./trackers";
import { PERKS, RECOGNITION, INSIGHTS, MEDICAL, WALLET, PLATFORM, REWARD, ONBOARDING, TOUR } from "./products";
import mixPanelService from "./trackers/mixpanel";
var Tracking = /** @class */ (function () {
    function Tracking() {
        var _this = this;
        this.setup = function (env) {
            trackers.setup(env);
        };
        this.trackEvent = function (name, data) {
            mixPanelService.trackEvent(name, data);
        };
        this.trackRecognitionEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: RECOGNITION
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackRewardEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: REWARD
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackPerksEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: PERKS
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackInsightsEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: INSIGHTS
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackMedicalEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: MEDICAL
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackWalletEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: WALLET
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackPlatformEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: PLATFORM
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackOnboardingEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: ONBOARDING
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
        this.trackTourEvent = function (name, dataAttributes) {
            var productData = {
                perkbox_product: TOUR
            };
            _this.trackEvent(name, __assign(__assign({}, productData), dataAttributes));
        };
    }
    return Tracking;
}());
export default new Tracking();
